import { supabase } from '../supabase';
import { validateWhatsApp } from '../phone-utils';
import { getUserRole } from '../auth';

export async function signIn(whatsapp: string, password: string) {
  if (!whatsapp || !password) {
    throw new Error('WhatsApp e senha são obrigatórios');
  }

  if (!validateWhatsApp(whatsapp)) {
    console.error('Invalid WhatsApp number format:', whatsapp);
    throw new Error('Número de WhatsApp inválido');
  }

  // Remove all non-digits and ensure it has 11 digits
  const digits = whatsapp.replace(/\D/g, '');
  if (digits.length !== 11) {
    console.error('WhatsApp number must have 11 digits:', digits.length);
    throw new Error('O número deve ter 11 dígitos (DDD + número)');
  }
  
  // Format email consistently for authentication
  const email = `${digits}@whatsapp.user`;
  console.log('Attempting sign in with email:', email);

  // Get user metadata
  const metadata = {
    name: '',
    whatsapp: digits,
    block: false,
    tipo_usuario: 'cliente'
  };

  try {
    // Sign out any existing session before attempting new sign in
    const { data: existingSession } = await supabase.auth.getSession();
    if (existingSession?.session) {
      console.log('Signing out existing session');
      await supabase.auth.signOut();
    }

    // Attempt authentication
    const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (authError) {
      console.error('Authentication error:', {
        error: authError,
        errorMessage: authError.message,
        triedEmail: email
      });

      if (authError.message === 'Invalid login credentials') {
        throw new Error(
          'Credenciais inválidas. Verifique seu número de WhatsApp e senha. ' +
          'Se esqueceu sua senha, use a opção "Esqueci minha senha".'
        );
      }

      throw new Error('Erro ao fazer login. Por favor, tente novamente.');
    }

    if (!authData.user) {
      throw new Error('Erro ao recuperar dados do usuário');
    }

    // Check if user is blocked
    const { data: isBlocked } = await supabase.rpc('is_user_blocked', { 
      user_id: authData.user.id 
    });

    if (isBlocked) {
      throw new Error('Sua conta está bloqueada. Entre em contato com o suporte através do email suporte@ftviagens.com.br para obter assistência.');
    }

    // Get user role
    const userRole = await getUserRole();
    if (userRole !== 'cliente' && userRole !== 'admin') {
      throw new Error('Tipo de usuário não autorizado');
    }

    console.log('Sign in successful for user:', authData.user.id);
    return authData;
  } catch (err) {
    console.error('Login error:', err);
    throw err instanceof Error ? err : new Error('Erro ao fazer login');
  }
}